import Route from '@ember/routing/route';
import { ajax } from 'discourse/lib/ajax';

export default class ProxyviewsBenchmarksCompareRoute extends Route {
  queryParams = {
    providers: { refreshModel: true },
  };

  async model(params) {
    const providers = params.providers || '';
    if (!providers) {
      return { summary: [], chart_series: [], providers: '' };
    }

    try {
      const data = await ajax('/benchmarks/compare', {
        data: { providers },
      });
      return {
        summary: data.summary || [],
        chart_series: data.chart_series || [],
        filters: data.filters || {},
        providers,
      };
    } catch (e) {
      return { summary: [], chart_series: [], providers, error: true };
    }
  }

  titleToken() {
    return 'Compare Benchmarks';
  }
}
